export const RouterNormal = [
  {
    path: "/normal/calendar", // 选择日期
    name: "在线购票",
    component: (resolve) => require(/* webpackChunkName: "normal" */ ["@/views/normal/Calendar"], resolve),
  },
  {
    path: "/normal/otherDates", // 其他日期
    name: "在线购票",
    component: (resolve) => require(/* webpackChunkName: "normal" */ ["@/views/normal/Stock"], resolve),
  },
  {
    path: "/normal/choice", // 选择门票
    name: "在线购票",
    component: (resolve) => require(/* webpackChunkName: "normal" */ ["@/views/normal/Choice"], resolve),
  },
  {
    path: "/normal/confirm", // 确认订单
    name: "确认订单",
    component: (resolve) => require(/* webpackChunkName: "normal" */ ["@/views/normal/Confirm"], resolve),
  },
  {
    path: "/normal/operationContacts/:venueType", // 添加联系人
    name: "添加联系人",
    component: (resolve) => require(/* webpackChunkName: "normal" */ ["@/views/normal/OperationContacts"], resolve),
  },
  {
    path: "/normal/operationContacts/:venueType", // 编辑联系人
    name: "编辑联系人",
    component: (resolve) => require(/* webpackChunkName: "normal" */ ["@/views/normal/OperationContacts"], resolve),
  },
  {
    path: "/normal/choiceContacts/:venueType", // 选择联系人
    name: "选择联系人",
    component: (resolve) => require(/* webpackChunkName: "normal" */ ["@/views/normal/ChoiceContacts"], resolve),
  },
  {
    path: "/normal/FWTK", // 网站隐私政策
    name: "网站隐私政策",
    component: (resolve) => require(/* webpackChunkName: "normal" */ ["@/views/normal/FWTK"], resolve),
  },
];
